import { ConcatAddressLine } from 'common/Addresses/AddressFormatters/Shared/AddressFormatHelper';

const usaIsoName = 'United States of America';

function GetW9FieldPathValueMap(addressPath, wellFormedAddress) {
  const isUnitedStates = wellFormedAddress?.addressCountry === usaIsoName;
  const fieldPathValueDictionary = [
    { key: `${ addressPath }.numberStreet`, value: ConcatAddressLine([wellFormedAddress?.addressLine1, wellFormedAddress?.addressLine2]) },
    { key: `${ addressPath }.cityStateAndZipCode`,
      value: ConcatAddressLine([
        wellFormedAddress?.addressLine3,
        wellFormedAddress?.addressLine4,
        wellFormedAddress?.addressPostalCode,
        isUnitedStates ? '' : wellFormedAddress?.addressCountry
      ], isUnitedStates)
    },
    { key: `${ addressPath }.country`, value: wellFormedAddress?.addressCountry ?? usaIsoName },
    { key: `${ addressPath }.countrySpecified`, value: !isUnitedStates }
  ];

  return fieldPathValueDictionary;
}

function GetW9WellFormedAddress(formAddress) {
  const wellFormedAddress = {
    line1: '',
    line2: '',
    line3: '',
    line4: '',
    postalCode: '',
    country: 'United States of America',
    countrySpecified: formAddress?.countrySpecified ?? false
  };

  const cityStateZipHasCountry = formAddress.countrySpecified
                                 && formAddress.country
                                 && formAddress.cityStateAndZipCode?.toLowerCase().endsWith(formAddress.country.toLowerCase());

  const cleanedCityStateZip = cityStateZipHasCountry
    ? formAddress.cityStateAndZipCode.slice(0, formAddress.cityStateAndZipCode.length - formAddress.country.length).replace(/(\s|,)+$/, '')
    : formAddress.cityStateAndZipCode;

  if (cityStateZipHasCountry) {
    wellFormedAddress.country = formAddress.country;
  }

  const isUnitedStates = wellFormedAddress?.country?.toLowerCase() === usaIsoName.toLowerCase();

  const splitLine1 = formAddress?.numberStreet?.split(',')?.map(x => x.trim())?.reverse() ?? ['', ''];
  const splitLine2 = cleanedCityStateZip?.split(',')?.map(x => x.trim())?.reverse() ?? ['', '', ''];

  if (splitLine1.length >= 2) {
    [wellFormedAddress.line2, ...wellFormedAddress.line1] = splitLine1;
  } else {
    [...wellFormedAddress.line1] = splitLine1;
  }

  if (splitLine2.length > 4 && !isUnitedStates && !cityStateZipHasCountry) {
    // Some countries include a comma such as "Bahamas, The", hence country1 and country2
    const [country1, country2, postalCode, line4, ...line3] = splitLine2;
    wellFormedAddress.country = `${ country2 }, ${ country1 }`;
    wellFormedAddress.postalCode = postalCode;
    wellFormedAddress.line4 = line4;
    wellFormedAddress.line3 = line3;
  } else if (splitLine2.length === 4 && !isUnitedStates && !cityStateZipHasCountry) {
    [wellFormedAddress.country, wellFormedAddress.postalCode, wellFormedAddress.line4, ...wellFormedAddress.line3] = splitLine2;
  } else if (splitLine2.length >= 3) {
    [wellFormedAddress.postalCode, wellFormedAddress.line4, ...wellFormedAddress.line3] = splitLine2;
  } else if (splitLine2.length === 2) {
    [wellFormedAddress.line4, ...wellFormedAddress.line3] = splitLine2;
  } else {
    [...wellFormedAddress.line3] = splitLine2;
  }

  wellFormedAddress.line1 = wellFormedAddress.line1.reverse().join(', ');
  wellFormedAddress.line3 = wellFormedAddress.line3.reverse().join(', ');

  return wellFormedAddress;
}

export function GetFieldPathValueMap(addressProps, wellFormedAddress) {
  return GetW9FieldPathValueMap('address', wellFormedAddress);
}

export function GetWellFormedAddress(addressProps, addressValues) {
  return GetW9WellFormedAddress(addressValues?.address);
}
